import { ThemeVariationType } from '@graphql/generated';
import { ThemeVariant } from '../../../Template.types';
import { THEME_ID } from '../useDesignTemplates.constants';

export const DEFAULT_VIDEO_BACKGROUND_TEMPLATE: ThemeVariant = {
  variationType: ThemeVariationType.brannan,
  imageUrl:
    'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-wanderlust_meadow-videobackground.jpg?v=1638397480',
  printUrl: '',
  vendor: 'Joy',
  tags: [],
  colors: ['Blue', 'Purple'],
  font: 'Cinzel',
  variantColor: null,
  variantName: null,
  variantThemeId: 'brannan-wanderlust_meadow-videoBackground',
  theme: {
    name: 'Wanderlust Meadow',
    themeId: 'blank',
    designLayouts: [],
    id: THEME_ID,
  },
  websiteDesignSettings: {
    colorPalette: {
      artBackground: '#FFFFFF',
      pageBackground: '#FFFFFF',
      pageFont: '#333333',
      linkAndButton: '#333333',
      artFont: '#333333',
    },
    pageTransparency: false,
    pageShadow: false,
    photoPresentationLayout: 'videoBackground',
    photoBackgroundPresentationSettings: {
      colors: {
        nameAndNavFontColor: '#FFFFFF',
        nameAndNavBackgroundColor: '#FFFFFF',
        nameAndNavBackgroundColorEnabled: false,
      },
      eventName: {
        textAlignment: 'center',
        pageAlignment: {
          x: 'center',
          y: 'center',
        },
      },
    },
    defaultHeaderVideo: {
      desktopUrl: 'https://player.vimeo.com/video/1138643681',
      mobileUrl: 'https://player.vimeo.com/video/1140234479',
      placeholderImageUrl:
        'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-wanderlust_meadow-videobackground.png?v=1638397480',
    },
    preserveDefaultVideo: true,
  },
  isStatic: true,
  hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-wanderlust_meadows-videoBackground.json',
};

export const VIDEO_BACKGROUND_DESIGN_TEMPLATES: Array<ThemeVariant> = [
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-you_and_me-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: [],
    font: 'Coiny',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-you_and_me-videoBackground',
    theme: {
      name: 'You and Me',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#ECEDEF',
        pageBackground: '#ECEDEF',
        pageFont: '#333333',
        linkAndButton: '#6C6C6C',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#FFFFFF',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'right',
          pageAlignment: {
            x: 'right',
            y: 'bottom',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138638945',
        mobileUrl: 'https://player.vimeo.com/video/1140871756',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-you_and_me-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-you_and_me-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-winterwood-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: [],
    font: 'Cinzel',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-winterwood-videoBackground',
    theme: {
      name: 'Winterwood',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#333333',
        linkAndButton: '#333333',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#FDFBF5',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138690705',
        mobileUrl: 'https://player.vimeo.com/video/1140233841',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-winterwood-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-winterwood-videoBackground.json',
  },
  DEFAULT_VIDEO_BACKGROUND_TEMPLATE,
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-reverie-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Blue', 'Purple'],
    font: 'Jost',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-reverie-videoBackground',
    theme: {
      name: 'Reverie',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#E7EDFF',
        pageBackground: '#E7EDFF',
        pageFont: '#4663BB',
        linkAndButton: '#231078',
        artFont: '#4663BB',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#4663BB',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138648084',
        mobileUrl: 'https://player.vimeo.com/video/1140235065',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-reverie-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-reverie-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-twilight-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Purple', 'Blue'],
    font: 'Antic Didone',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-twilight-videoBackground',
    theme: {
      name: 'Twilight',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#7C8ABF',
        pageBackground: '#7C8ABF',
        pageFont: '#FFFFFF',
        linkAndButton: '#FFD5E0',
        artFont: '#FFFFFF',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#FCE9D7',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138642418',
        mobileUrl: 'https://player.vimeo.com/video/1139722505',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-twilight-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-twilight-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-pink_champagne-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Pink', 'Beige'],
    font: 'Homemade Apple',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-pink_champagne-videoBackground',
    theme: {
      name: 'Pink Champagne',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#F3EEE8',
        pageBackground: '#F3EEE8',
        pageFont: '#6B6B6B',
        linkAndButton: '#785E5C',
        artFont: '#6B6B6B',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#785E5C',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138694454',
        mobileUrl: 'https://player.vimeo.com/video/1140235840',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-pink_champagne-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-pink_champagne-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-pampas-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Green', 'Beige'],
    font: 'Playfair Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-pampas-videoBackground',
    theme: {
      name: 'Pampas',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#F5F2E4',
        pageBackground: '#F5F2E4',
        pageFont: '#333333',
        linkAndButton: '#7D8E51',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#F5F2E4',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138643504',
        mobileUrl: 'https://player.vimeo.com/video/1140236101',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-pampas-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-pampas-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-the_marigold-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Orange', 'Blue'],
    font: 'Meddon',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-the_marigold-videoBackground',
    theme: {
      name: 'The Marigold',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#333333',
        linkAndButton: '#5C8CC4',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#FFFFFF',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'bottom',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138642677',
        mobileUrl: 'https://player.vimeo.com/video/1140236503',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-the_marigold-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-marigold-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-tutti_frutti-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Green'],
    font: 'Bungee',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-tutti_frutti-videoBackground',
    theme: {
      name: 'Tutti Frutti',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#DFFCB5',
        pageBackground: '#DFFCB5',
        pageFont: '#000000',
        linkAndButton: '#006C28',
        artFont: '#000000',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#DFFCB5',
          nameAndNavBackgroundColor: '#57BA5D',
          nameAndNavBackgroundColorEnabled: true,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138643570',
        mobileUrl: 'https://player.vimeo.com/video/1140237245',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-tutti_frutti-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-tutti%20fruitti-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-palm_tree-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Beige'],
    font: 'Mrs Saint Delafield',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-palm_tree-videoBackground',
    theme: {
      name: 'Palm Tree',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#F1ECEB',
        pageBackground: '#F1EFEB',
        pageFont: '#4B4242',
        linkAndButton: '#654141',
        artFont: '#4B4242',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#4B4242',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'right',
          pageAlignment: {
            x: 'right',
            y: 'top',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138702672',
        mobileUrl: 'https://player.vimeo.com/video/1140237640',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-palm_tree-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-palm_tree-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-confetti-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['White'],
    font: 'Windsong',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-confetti-videoBackground',
    theme: {
      name: 'Confetti',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#333333',
        linkAndButton: '#333333',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#FFFFFF',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138690809',
        mobileUrl: 'https://player.vimeo.com/video/1140237939',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-confetti-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-confetti-videoBackground.json',
  },
  {
    variationType: ThemeVariationType.brannan,
    imageUrl: 'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/brannan_thumbnails/brannan-snowflakes-videobackground.jpg?v=1638397480',
    printUrl: '',
    vendor: 'Joy',
    tags: [],
    colors: ['Purple'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'brannan-snowflakes-videoBackground',
    theme: {
      name: 'Snowflakes',
      themeId: 'blank',
      designLayouts: [],
      id: THEME_ID,
    },
    websiteDesignSettings: {
      colorPalette: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#333333',
        linkAndButton: '#5550B5',
        artFont: '#333333',
      },
      pageTransparency: false,
      pageShadow: false,
      photoPresentationLayout: 'videoBackground',
      photoBackgroundPresentationSettings: {
        colors: {
          nameAndNavFontColor: '#5550B5',
          nameAndNavBackgroundColor: '#FFFFFF',
          nameAndNavBackgroundColorEnabled: false,
        },
        eventName: {
          textAlignment: 'center',
          pageAlignment: {
            x: 'center',
            y: 'center',
          },
        },
      },
      defaultHeaderVideo: {
        desktopUrl: 'https://player.vimeo.com/video/1138702920',
        mobileUrl: 'https://player.vimeo.com/video/1140238104',
        placeholderImageUrl:
          'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/brannan-snowflakes-videobackground.png?v=1638397480',
      },
      preserveDefaultVideo: true,
    },
    isStatic: true,
    hoverAnimationUrl: 'https://withjoy.com/assets/public/lottie/templates/brannan-snowflakes-videoBackground.json',
  },
];
